import { getAllowedAdminDomains } from '@cdw-ae/common-data';
import { sharedUrls } from './environment.urls';
import { REVISION, VERSION } from './revision';

export const environment = {
  firebase: {
    apiKey: 'AIzaSyDjFZ5icOTMjN8GgK3Qz7YrUReVvlCbFA8',
    authDomain: 'spog-gopher-staging.firebaseapp.com',
    projectId: 'spog-gopher-staging',
    storageBucket: 'spog-gopher-staging.firebasestorage.app',
    messagingSenderId: '2679279683',
    appId: '1:2679279683:web:aa49bc27f6e8b9302844f6',
  },
  urls: {
    backendApi: 'https://spog-backend.staging.gopher.cdw.com/api',
    ...sharedUrls,
  },
  production: false,
  // Client-side add-time domain allowlist (server is authoritative). Staging
  // does NOT permit the gafetest test domain.
  allowedAdminEmailDomains: getAllowedAdminDomains('staging'),
  revision: REVISION,
  version: VERSION,
};
